import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { FaHourglassEnd } from 'react-icons/fa';
import { DataService } from '../../../config/dataService/dataService';

const LeadFunnelPerformance = () => {
  const [loading, setLoading] = useState(true);
  const [funnelData, setFunnelData] = useState([]);

  const STAGE_CONFIG = [
    { key: 1, stage: 'Fresh Leads', tag: 'fresh-leads', endpoint: '/students?page=1&limit=1&levelTag=fresh-leads', description: 'New leads captured from various sources'},
    { key: 2, stage: 'Ready for Aptitude Test', tag: 'exam-assigned', endpoint: '/students?page=1&limit=1&levelTag=exam-assigned', description: 'Leads qualified for aptitude/eligibility'},
    { key: 3, stage: 'Aptitude Test Submitted', tag: 'ready-for-counselling', endpoint: '/students?page=1&limit=1&levelTag=ready-for-counselling', description: 'Candidates submitted aptitude test'},
    { key: 4, stage: 'Ready for Interview', tag: 'ready-for-interview', endpoint: '/students?page=1&limit=1&levelTag=ready-for-interview', description: 'Shortlisted for personal interview'}, 
    { key: 5, stage: 'Ready for Enrollment', tag: 'final-passed-student', endpoint: '/students?page=1&limit=1&levelTag=final-passed-student', description: 'Selected & ready for enrollment'},
    { key: 6, stage: 'Enrolled with HBIMS', tag: 'enrolled-student', endpoint: '/students?page=1&limit=1&levelTag=enrolled-student', description: 'Successfully enrolled with HBIMS'},
    { key: 7, stage: 'Paid Fresh Leads', tag: 'paid-fresh-leads', endpoint: '/students?page=1&limit=1&levelTag=paid-fresh-leads', description: 'Fresh leads with advance paid'},
    { key: 8, stage: 'Cold Leads', tag: 'cold-leads', endpoint: '/v1/cold-leads?page=1&limit=1', description: 'Not interested / not reachable'},
  ];

  useEffect(() => {
    const fetchAllCounts = async () => {
      setLoading(true);
      try {
        const apiRequests = STAGE_CONFIG.map((item) =>
          DataService.get(item.endpoint)
        );

        const responses = await Promise.all(apiRequests);

        const countsMap = {};
        STAGE_CONFIG.forEach((item, index) => {
          countsMap[item.tag] = responses[index]?.data?.data?.count || 0;
        });

        const calculatedData = STAGE_CONFIG.map((item, index, array) => {
          const currentCount = countsMap[item.tag] || 0;

          let conversionRate = '—';
          if (index === 0) {
            conversionRate = '100.00%';
          } else if (item.tag === 'cold-leads') {
            conversionRate = '100.00%';
          } else {
            const previousCount = countsMap[array[index - 1].tag] || 0;
            if (previousCount > 0) {
              const rawRate = (currentCount / previousCount) * 100;
              const cappedRate = Math.min(rawRate, 100);
              conversionRate = `${cappedRate.toFixed(2)}%`;
            } else {
              conversionRate = '0.00%';
            }
          }

          return {
            key: item.key,
            stage: item.stage,
            description: item.description,
            totalLeads: currentCount.toLocaleString(),
            conversion: conversionRate,
          };
        });

        setFunnelData(calculatedData);
      } catch (error) {
        console.error('Error fetching stage counts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllCounts();
  }, []);

  const columns = [
    { title: '#', dataIndex: 'key', key: 'key', width: 50, align: 'center' },
    {
      title: 'STAGE',
      dataIndex: 'stage',
      key: 'stage',
      render: (text) => (
        <span className="stage-cell">
          <span className="hourglass">
            <FaHourglassEnd color="var(--brand-maroon)" />
          </span>{' '}
          {text}
        </span>
      ),
    },
    { title: 'DESCRIPTION', dataIndex: 'description', key: 'description', className: 'desc-cell' },
    { title: 'TOTAL LEADS', dataIndex: 'totalLeads', key: 'totalLeads', align: 'center', className: 'bold-cell' },
    { title: 'CONVERSION TO NEXT STAGE', dataIndex: 'conversion', key: 'conversion', align: 'center', className: 'bold-cell' },
  ];

  return (
    <div className="lead-funnel-wrapper">
      <Cards title="LEAD FUNNEL PERFORMANCE" className="overview-custom-card" border={false}>
        <Table
          columns={columns}
          dataSource={funnelData}
          loading={loading}
          pagination={false}
          className="custom-funnel-table"
        />
        <div className="funnel-footer">
          <span>Last Updated: {new Date().toLocaleString()}</span>
          <span>All numbers are dynamic & real time</span>
        </div>
      </Cards>
    </div>
  );
};

export default LeadFunnelPerformance;
